import { API_URL, tenantConfig } from 'config';
import AuthService from 'services/AuthService';
import { HttpService } from 'services/HttpService';
import AccountPortalBanner from 'store/types/AccountPortalBanner';
import { httpRequestWrapper } from 'util/Request';

class AccountPortalService {
  // Reads whether the signed-in user should see the Account Portal banner. The banner is
  // non-essential, so a 401 here rejects without logging the user out; UserGuard owns that.
  public static getBanner(): Promise<AccountPortalBanner> {
    return new Promise<AccountPortalBanner>(
      (resolve: (data: AccountPortalBanner) => void, reject: (error: string) => void) => {
        httpRequestWrapper<AccountPortalBanner>(
          HttpService.get(`${API_URL}/accountportal/banner`, {
            headers: {
              TenantId: tenantConfig.id,
              authorization: AuthService.getBearerToken(),
            },
          }),
          resolve,
          reject,
          false
        );
      }
    );
  }
}
export default AccountPortalService;
